import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  landingStoryblokComponents,
  MarketingCarousel,
} from '@cinch-nx/landing-ui-shared'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import { ComponentLayouts } from '@cinch-nx/storyblok-utils'
import { Accordion } from '../accordion'
import { Badge } from '../badge'
import { Image } from '../image'
import { Logo } from '../logo'
import { Table } from '../table'

const {
  HighlightsSection,
  Table: StoryblokTable,
  ...slimComponents
}: ComponentMap = {
  ...landingStoryblokComponents,
  LoopingCarousel: MarketingCarousel,
  Table,
  Accordion,
  ...globalStoryblokComponents,
}

export const servicingStoryblokComponents: ComponentLayouts = {
  noWrapper: { Table: StoryblokTable, Accordion },
  fullWidthWrapper: { HighlightsSection },
  slimWrapper: slimComponents,
}

/**
 * Bloks the shared LandingHeroV2 renders on servicing pages, kept apart from
 * the body map because the hero renders them inline, without a wrapper.
 * TODO: temporary, see LayoutProps.heroComponents in landing-ui-shared.
 */
export const servicingHeroComponents: ComponentLayouts = {
  noWrapper: { DS_Badge: Badge, DS_Logo: Logo, DS_Image: Image },
}
